/**
 * WebView 감지 및 외부 브라우저 안내 컴포넌트
 *
 * 카카오톡 등 앱 내 브라우저에서 접근 시 외부 브라우저로 안내
 */
import { AlertTriangle, ExternalLink } from "lucide-react";

import { Button } from "~/core/components/ui/button";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "~/core/components/ui/card";

export function WebViewWarning() {
  const handleOpenInBrowser = () => {
    // 홈 화면 URL로 복사 (로그인 페이지가 아닌 메인 화면)
    const homeUrl = window.location.origin + "/";
    navigator.clipboard.writeText(homeUrl);

    // 사용자에게 안내
    alert(
      "링크가 복사되었습니다!\n\n크롬이나 삼성인터넷 등 외부 브라우저에서\n붙여넣기 후 접속해주세요.",
    );
  };

  return (
    <Card className="mx-auto max-w-md border-orange-200 bg-orange-50 dark:border-orange-800 dark:bg-orange-950/30">
      <CardHeader className="text-center">
        <div className="mx-auto mb-2 flex h-12 w-12 items-center justify-center rounded-full bg-orange-100 dark:bg-orange-900">
          <AlertTriangle className="h-6 w-6 text-orange-600 dark:text-orange-400" />
        </div>
        <CardTitle className="text-lg text-orange-900 dark:text-orange-100">
          외부 브라우저에서 접속해주세요
        </CardTitle>
        <CardDescription className="text-orange-700 dark:text-orange-300">
          현재 앱 내 브라우저에서는 Google 로그인이 제한됩니다
        </CardDescription>
      </CardHeader>

      <CardContent className="space-y-4">
        <div className="text-sm text-orange-800 dark:text-orange-200">
          <p className="mb-2">
            📱 <strong>해결 방법:</strong>
          </p>
          <ol className="list-inside list-decimal space-y-1 text-xs">
            <li>아래 버튼을 눌러 링크 복사</li>
            <li>크롬, 삼성인터넷 등 외부 브라우저 열기</li>
            <li>주소창에 붙여넣기 후 접속</li>
            <li>Google 로그인 정상 진행</li>
          </ol>
        </div>

        <Button
          onClick={handleOpenInBrowser}
          className="w-full bg-orange-600 hover:bg-orange-700 dark:bg-orange-700 dark:hover:bg-orange-800"
        >
          <ExternalLink className="mr-2 h-4 w-4" />
          링크 복사하기
        </Button>

        <div className="text-xs text-orange-600 dark:text-orange-400">
          💡 카카오톡에서 '⋯' → '기타 브라우저에서 열기'도 가능합니다
        </div>
      </CardContent>
    </Card>
  );
}
